import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { Spinner } from "../../../../components";
import { useConvenios, useDeleteConvenio } from "../hooks/useConvenio";
import EditarConvenio from "./EditarConvenio";

const ConvenioList = () => {
  const { data: convenios = [], isLoading, isError, error, refetch } = useConvenios();
  const { mutate: deleteConvenio, isPending: isDeleting } = useDeleteConvenio();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedConvenio, setSelectedConvenio] = useState(null);

  const handleConfirmarExclusao = (convenio) => {
    setSelectedConvenio(convenio);
    onOpen();
  };

  const handleExcluir = () => {
    if (!selectedConvenio?._id) return;
    deleteConvenio(selectedConvenio._id, {
      onSuccess: () => {
        setSelectedConvenio(null);
        onClose();
      },
    });
  };

  if (isLoading) return <Spinner />;

  if (isError) {
    return (
      <Box p={6} bg="white">
        <Text color="red.500">Erro ao carregar convênios.</Text>
        <Text mt={2}>{error?.message || 'Não foi possível consultar os convênios. Tente novamente.'}</Text>
        <Button mt={3} onClick={() => refetch()}>Tentar novamente</Button>
      </Box>
    );
  }

  if (!convenios.length) {
    return <Text color="gray.500">Nenhum convênio encontrado para a clínica selecionada.</Text>;
  }

  return (
    <Box>
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Ações</Th>
              <Th>Nome do Convênio</Th>
              <Th>Registro ANS</Th>
              <Th>CNPJ</Th>
              <Th>Telefone</Th>
            </Tr>
          </Thead>
          <Tbody>
            {convenios.map((convenio) => (
              <Tr key={convenio._id}>
                <Td>
                  <Menu>
                    <MenuButton as={Button} size="sm" variant="outline">
                      Opções
                    </MenuButton>
                    <MenuList>
                      <EditarConvenio data={convenio} />
                      <MenuItem onClick={() =>
                        handleConfirmarExclusao(convenio)
                      }>
                        Excluir
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
                <Td>{convenio.nomeConvenioCompleto}</Td>
                <Td>{convenio.registroANS}</Td>
                <Td>{convenio.cnpj}</Td>
                <Td>{convenio.telefone}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmação de Exclusão</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Tem certeza que deseja excluir o convênio{" "}
            <strong>{selectedConvenio?.nomeConvenioCompleto}</strong>?
          </ModalBody>
          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={onClose} isDisabled={isDeleting}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleExcluir} isLoading={isDeleting}>
              Excluir
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ConvenioList;
